export class UsersBalanceReportEntry {
    public username: string;
    public userId: string;
    public cashIn: { key: string; value: number }[] = [];
    public cashOut: { key: string; value: number }[] = [];
    public cashBalance: { key: string; value: number }[] = [];
    public manualDeposit: { key: string; value: number }[] = [];
    public balance: { key: string; value: number }[] = [];
    public kitWithdrawn: boolean;
    public endShiftDeposited: boolean;

    constructor() {}

    parse(obj: any) {
        this.username = obj.Username;
        this.userId = obj.UserId;

        for (let key in obj.CashIn) this.cashIn.push({ key: key, value: obj.CashIn[key] });
        for (let key in obj.CashOut) this.cashOut.push({ key: key, value: obj.CashOut[key] });
        for (let key in obj.CashBalance) this.cashBalance.push({ key: key, value: obj.CashBalance[key] });
        for (let key in obj.ManualDeposit) this.manualDeposit.push({ key: key, value: obj.ManualDeposit[key] });
        for (let key in obj.Balance) this.balance.push({ key: key, value: obj.Balance[key] });

        this.kitWithdrawn = obj.KitWithdrawn;
        this.endShiftDeposited = obj.EndShiftDeposited;
    }
}
